import { styled } from '@mui/material/styles';
import { Switch, FormControl } from '@mui/material';

export const StyledFormControl = styled(FormControl)(({ theme }) => ({
  '& .MuiFormControlLabel-root': {
    marginLeft: 0,
    marginRight: 0,
    
    '& .MuiFormControlLabel-label': {
      color: theme.palette.text.primary,
      fontSize: theme.typography.body1.fontSize,
      
      '&.Mui-disabled': {
        color: theme.palette.text.disabled,
      },
    },
  },
  
  '& .MuiFormHelperText-root': {
    marginTop: theme.spacing(0.5),
    marginLeft: 0,
    fontSize: theme.typography.caption.fontSize,
    
    '&.Mui-error': {
      color: theme.palette.error.main,
    },
  },
}));

export const StyledSwitch = styled(Switch)(({ theme }) => {
  // Check if we're in high contrast mode
  const isHighContrast = theme.palette.mode === 'dark' &&
    theme.palette.primary.main === '#FFFFFF'; // High contrast dark theme has white primary

  return {
    width: 47,
    height: 24,
    padding: 0,

    '& .MuiSwitch-switchBase': {
      padding: 1,
      transform: 'translateX(2px)',

      '&.Mui-checked': {
        color: '#fff',
        transform: 'translateX(22px)',

        '& + .MuiSwitch-track': {
          opacity: 1,
          backgroundColor: theme.palette.primary.main,
        },

        '& .MuiSwitch-thumb': {
          backgroundColor: isHighContrast ? '#000000' : theme.palette.common.white,
        },
      },

      '&:not(.Mui-checked)': {
        '& .MuiSwitch-thumb': {
          backgroundColor: isHighContrast ? '#ffffff' : theme.palette.primary.main,
        },
      },
    },

    '& .MuiSwitch-thumb': {
      backgroundColor: theme.palette.primary.main,
      width: 18,
      height: 18,
      boxShadow: 'none',
    },

    '& .MuiSwitch-track': {
      opacity: 1,
      backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[700] : theme.palette.grey[300],
      borderRadius: 12,
      ...(isHighContrast && {
        border: '2px solid #ffffff',
      }),
    },

    // Size variants
    '&.MuiSwitch-sizeSmall': {
      width: 36,
      height: 20,

      '& .MuiSwitch-switchBase': {
        padding: 2,
        transform: 'translateX(2px)',

        '&.Mui-checked': {
          transform: 'translateX(16px)',
        },
      },

      '& .MuiSwitch-thumb': {
        width: 14,
        height: 14,
      },
    },
  };
});